import React from 'react'

import PropTypes from 'prop-types'
import { QUERY_EDGE_VALUES } from 'utils/constants'
import strings from 'utils/strings'
import { useSelector } from 'hooks/redux'
import { getIsEditing } from 'selectors/navigator'

import { Button, RadioButtonGroup } from 'components/patterns'
import EdgeImg from 'components/feature/EdgeImg'
import { useHelpModal } from 'components/HelpModal'

import { Icon__Info as IconInfo } from 'components/patterns/Icon/components'
import ReadOnlyEditor from '../ReadOnlyParameterValue'
import HelpContent from './HelpContent'

const EdgeEditor = ({ edge, onEdgeChange, uri }) => {
  const { openModal } = useHelpModal()
  const menuOptions = QUERY_EDGE_VALUES.map((edgeValue) => ({
    key: edgeValue,
    value: edgeValue,
    image: <EdgeImg edge={edgeValue} data-img-value={edgeValue} />,
  }))

  const isEditing = useSelector(getIsEditing)

  if (!isEditing) {
    return <ReadOnlyEditor uri={uri} />
  }

  const handleModal = () => openModal(<HelpContent />)

  return (
    <>
      <RadioButtonGroup
        label={strings.edge_detection}
        currentValue={edge}
        onChange={onEdgeChange}
        vertical
        buttons={menuOptions}
        className="edge-editor"
        radioGroupClassName="edge-trigger-radio-group"
      />
      <Button
        link
        onClick={handleModal}
        style={{ marginTop: 3, alignSelf: 'flex-start' }}
      >
        <IconInfo
          style={{ display: 'inline-block', verticalAlign: 'middle' }}
        />{' '}
        {strings.what_is_this}
      </Button>
    </>
  )
}

EdgeEditor.propTypes = {
  edge: PropTypes.string,
  onEdgeChange: PropTypes.func,
  uri: PropTypes.string,
}

export default EdgeEditor
